import styled from "styled-components/macro";
import { Card as DSCard } from "@gcs/design-system/react";

export const Card = styled(DSCard)({
  borderRadius: "0",
  boxShadow: "none",
});
